import { show } from "@intercom/messenger-js-sdk";

import { ROUTES } from "~/constants/routing";
import { HELP_CENTER_LINK, type SiteLink } from "~/constants/socials";
import { BaseCategory } from "~/types/baseCategory";

import type { IFooterCategory } from "./types";

export const NEWSLETTER_HEADING = "Follow the signals, not the noise";

export const NEWSLETTER_DESCRIPTION =
  "Get insights on market conviction, notable shifts, and what the data is quietly signaling.";

export const FOOTER_CATEGORIES: IFooterCategory[] = [
  {
    slug: BaseCategory.Companies,
    name: "Companies",
    sub: "Predictions & odds",
  },
  {
    slug: BaseCategory.Financials,
    name: "Financials",
    sub: "Forecasts & predictions",
  },
  { slug: BaseCategory.Crypto, name: "Crypto", sub: "Price predictions" },
  { slug: BaseCategory.Other, name: "Other", sub: "Predictions" },
  {
    slug: BaseCategory.Economics,
    name: "Economics",
    sub: "Predictions & forecasts",
  },
  { slug: BaseCategory.Politics, name: "Politics", sub: "Odds & predictions" },
  {
    slug: BaseCategory.Elections,
    name: "Elections",
    sub: "Odds & predictions",
  },
  {
    slug: BaseCategory.ScienceAndTechnology,
    name: "Science and Technology",
    sub: "Trends & predictions",
  },
  {
    slug: BaseCategory.Entertainment,
    name: "Entertainment",
    sub: "Trends & predictions",
  },
  { slug: BaseCategory.Sports, name: "Sports", sub: "Odds & predictions" },
];

export const RESOURCE_LINKS: SiteLink[] = [
  { label: "Dashboards", to: ROUTES.highlights.createURL() },
  { label: "Insights", to: ROUTES.insights.createURL() },
  { label: "Indices", to: ROUTES.warIndex.createURL() },
  { label: "Trending", to: ROUTES.trending.createURL() },
  { label: "Breaking", to: ROUTES.breaking.createURL() },
];

export const COMPANY_LINKS: SiteLink[] = [
  {
    label: "Brand Kit",
    to: "https://brandfetch.com/predictionhero.com",
    target: "_blank",
  },
  { label: "API & Data Licensing", to: ROUTES.data.createURL() },
  { label: "Help Center", to: HELP_CENTER_LINK, target: "_blank" },
  { label: "Contact", action: show },
];

export const LEGAL_LINKS: SiteLink[] = [
  { label: "Disclaimer", to: ROUTES.disclaimer.createURL() },
  { label: "Privacy Policy", to: ROUTES.privacyPolicy.createURL() },
  { label: "Terms of Use", to: ROUTES.termsOfUse.createURL() },
];
